module.exports = __webpack_public_path__ + "static/media/gif2.b4964d88.gif";